import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * PasswordInput — text input with a show/hide toggle.
 * Same API as shadcn Input; pass everything except `type`.
 * Use `data-testid` on the field; the toggle button reuses it with `-toggle`.
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { className = "", ...props },
  ref,
) {
  const [visible, setVisible] = useState(false);
  const testId = props["data-testid"];
  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={visible ? "text" : "password"}
        className={`pr-11 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="absolute inset-y-0 right-0 flex items-center justify-center w-10 text-[#6F828A] hover:text-[#2E3A3F] transition-colors"
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        {visible ? <EyeOff className="w-4 h-4" strokeWidth={1.5} /> : <Eye className="w-4 h-4" strokeWidth={1.5} />}
      </button>
    </div>
  );
});
